import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { combineReducers, createSlice } from '@reduxjs/toolkit';
import { initialEntityStructure } from 'libs/utils/redux';
import { UiState as UiStateEnum } from 'constants/ui';
import { stateName, FeedbackScreen } from './constants';
export const initialDataState = _objectSpread(_objectSpread({}, initialEntityStructure), {}, {
  byTranslatedId: {}
});
export const initialUiState = {
  uiState: UiStateEnum.Idle,
  feedbackState: {},
  currentPage: 0,
  totalPages: 0
};

const feedbackGetSuccess = (draft, action) => {
  const {
    feedback
  } = action.payload.feedbackData;
  feedback.forEach(item => {
    draft.byId[item.id] = item;
    draft.ids.push(item.id);
  });
};

const feedbackDeleteSuccess = (draft, action) => {
  const {
    feedbackId
  } = action.payload;
  draft.ids = draft.ids.filter(itemId => itemId !== feedbackId);
  delete draft.byId[feedbackId];
};

const updateFeedback = (draft, action) => {
  const {
    feedback
  } = action.payload;
  draft.byId[feedback.id] = feedback;
  delete draft.byTranslatedId[feedback.id];
};

const feedbackTranslateSuccess = (draft, action) => {
  const {
    feedback
  } = action.payload;
  draft.byTranslatedId[feedback.id] = feedback;
};

const feedbackClearIds = draft => {
  draft.ids = [];
};

const dataSlice = createSlice({
  name: stateName,
  initialState: initialDataState,
  reducers: {
    feedbackGetSuccess,
    feedbackDeleteSuccess,
    feedbackTranslateSuccess,
    feedbackCommentCreateSuccess: updateFeedback,
    feedbackCommentEditSuccess: updateFeedback,
    feedbackCommentDeleteSuccess: updateFeedback,
    feedbackClearIds
  }
});

const setFeedbackUiStateById = (draft, feedbackId, uiState) => {
  draft.feedbackState[feedbackId].uiState = uiState;
};

const setFeedbackScreenById = (draft, feedbackId, screen) => {
  draft.feedbackState[feedbackId].screen = screen;
};

const setFeedbackUiState = uiState => (draft, action) => {
  const {
    feedbackId
  } = action.payload;
  setFeedbackUiStateById(draft, feedbackId, uiState);
};

const setFeedbackScreen = screen => (draft, action) => {
  const {
    feedbackId
  } = action.payload;
  setFeedbackScreenById(draft, feedbackId, screen);
};

const feedbackGetRequest = draft => {
  draft.uiState = UiStateEnum.Pending;
};

const feedbackGetFailure = draft => {
  draft.uiState = UiStateEnum.Failure;
};

const feedbackGetSuccessUi = (draft, action) => {
  const {
    feedback,
    pagination
  } = action.payload.feedbackData;
  const {
    totalPages,
    currentPage
  } = pagination;
  draft.totalPages = totalPages;
  draft.currentPage = currentPage;
  draft.uiState = UiStateEnum.Success;

  if (draft.showFilters === undefined) {
    draft.showFilters = feedback.length > 0;
  }

  feedback.forEach(item => {
    draft.feedbackState[item.id] = {
      uiState: UiStateEnum.Idle,
      screen: FeedbackScreen.View,
      error: null,
      isTranslated: false
    };
  });
};

const feedbackDeleteSuccessUiState = (draft, action) => {
  const {
    feedbackId
  } = action.payload;
  delete draft.feedbackState[feedbackId];
};

const feedbackToggleTranslated = (draft, action) => {
  const {
    feedbackId,
    localize
  } = action.payload;
  draft.feedbackState[feedbackId].isTranslated = localize;
};

const feedbackActionSuccess = (draft, action) => {
  const {
    feedbackId
  } = action.payload;
  draft.feedbackState[feedbackId].isTranslated = false;
  setFeedbackUiStateById(draft, feedbackId, UiStateEnum.Success);
  setFeedbackScreenById(draft, feedbackId, FeedbackScreen.View);
};

const feedbackActionFailure = (draft, action) => {
  const {
    feedbackId,
    error
  } = action.payload;
  setFeedbackUiStateById(draft, feedbackId, UiStateEnum.Failure);
  draft.feedbackState[feedbackId].error = error;
};

const feedbackTranslateSuccessUi = (draft, action) => {
  const {
    feedbackId,
    localize
  } = action.payload;
  setFeedbackUiStateById(draft, feedbackId, UiStateEnum.Success);
  draft.feedbackState[feedbackId].isTranslated = localize;
};

const feedbackToggleCancel = (draft, action) => {
  const {
    feedbackId
  } = action.payload;
  setFeedbackUiStateById(draft, feedbackId, UiStateEnum.Idle);
  setFeedbackScreenById(draft, feedbackId, FeedbackScreen.View);
  draft.feedbackState[feedbackId].error = null;
};

const feedbackResetCurrentPage = draft => {
  draft.currentPage = 0;
};

const uiSlice = createSlice({
  name: stateName,
  initialState: initialUiState,
  reducers: {
    feedbackGetRequest,
    feedbackGetFailure,
    feedbackDeleteRequest: setFeedbackUiState(UiStateEnum.Pending),
    feedbackDeleteFailure: feedbackActionFailure,
    feedbackTranslateRequest: setFeedbackUiState(UiStateEnum.Pending),
    feedbackTranslateFailure: feedbackActionFailure,
    feedbackCommentCreateRequest: setFeedbackUiState(UiStateEnum.Pending),
    feedbackCommentCreateFailure: feedbackActionFailure,
    feedbackCommentEditRequest: setFeedbackUiState(UiStateEnum.Pending),
    feedbackCommentEditFailure: feedbackActionFailure,
    feedbackCommentDeleteRequest: setFeedbackUiState(UiStateEnum.Pending),
    feedbackCommentDeleteFailure: feedbackActionFailure,
    feedbackToggleReply: setFeedbackScreen(FeedbackScreen.CreateComment),
    feedbackToggleCommentEdit: setFeedbackScreen(FeedbackScreen.EditComment),
    feedbackToggleDelete: setFeedbackScreen(FeedbackScreen.DeleteFeedback),
    feedbackToggleCommentDelete: setFeedbackScreen(FeedbackScreen.DeleteComment),
    feedbackToggleCancel,
    feedbackToggleTranslated,
    feedbackResetCurrentPage
  },
  extraReducers: {
    [dataSlice.actions.feedbackGetSuccess.type]: feedbackGetSuccessUi,
    [dataSlice.actions.feedbackDeleteSuccess.type]: feedbackDeleteSuccessUiState,
    [dataSlice.actions.feedbackTranslateSuccess.type]: feedbackTranslateSuccessUi,
    [dataSlice.actions.feedbackCommentCreateSuccess.type]: feedbackActionSuccess,
    [dataSlice.actions.feedbackCommentEditSuccess.type]: feedbackActionSuccess,
    [dataSlice.actions.feedbackCommentDeleteSuccess.type]: feedbackActionSuccess
  }
});
export const dataReducer = dataSlice.reducer;
export const uiReducer = uiSlice.reducer;
const userFeedbackReducer = combineReducers({
  ui: uiReducer,
  data: dataReducer
});
export const actions = _objectSpread(_objectSpread({}, dataSlice.actions), uiSlice.actions);
export const plug = {
  [stateName]: userFeedbackReducer
};
export default userFeedbackReducer;